<template>
  <div class="payslip-table mx-8 my-4">
    <v-row no-gutters>
      <v-col cols="12">
        <table style="width: 100%; background-color: white" class="table border-bottom-none">
          <tbody>
            <!-- <tr style="height: 30px">
              <td style="width: 56px; height: 30px"></td>
              <td style="width: 54.6667px; height: 30px"></td>
              <td style="width: 55.3333px; height: 30px"></td>
              <td style="width: 56px; height: 30px"></td>
              <td style="width: 54px; height: 30px"></td>
              <td style="width: 53px; height: 30px"></td>
              <td style="width: 56px; height: 30px"></td>
              <td style="width: 52px; height: 30px"></td>
              <td style="width: 55px; height: 30px"></td>
              <td style="width: 56px; height: 30px"></td>
              <td style="width: 56px; height: 30px"></td>
              <td style="width: 56px; height: 30px"></td>
            </tr> -->
            <tr>
              <td
                class="border-right-none"
                style="height: 100px; padding-left: 20px; text-align: left"
                colspan="2"
                rowspan="2"
              >
                <img :src="currentInstitution.logo" height="100px" />
              </td>
              <td class="border-bottom-none border-sides-none" colspan="8">
                <img v-if="payslipSettings.font_image" :src="payslipSettings.font_image" style="height:45px;padding-top:8px;"/> 
                <!-- <span v-else class="bold" style="height: 22px; font-size: 24px;">{{ currentInstitution.name }}</span> -->
                <span v-else class="bold" style="height: 22px; font-size: 24px">{{
                  currentInstitution.name
                }}</span>
                <p class="py-0 mb-0">{{ currentInstitution.address }}</p>
              </td>
              <td
                class="border-left-none"
                style="height: 22px"
                colspan="2"
                rowspan="2"
              >
                {{
                  payslip.approved == null
                    ? "PENDING"
                    : !payslip.approved
                    ? "REJECTED"
                    : "APPROVED"    
                }}
              </td>
            </tr>
            <tr style="height: 30px">
              <td class="border-top-none border-sides-none" colspan="8">
                <b>Payslip - {{ payslip.payslip_group.title }}</b>
              </td>
            </tr>
            <tr style="height: 30px" v-if="payslipSettings.show_payslip_number">
              <td class="border-none" colspan="2">
                <span>Payslip Number: </span>
              </td>
              <td class="border-none text-left" colspan="4">
                <strong>{{
                  payslip.payslip_number
                }}</strong>
              </td>
              <td class="border-none" colspan="2">
                <span v-if="!payslipSettings.show_attendance_details">Pan Card no : </span>
              </td>
              <td class="border-none text-left" colspan="4">
                <strong>{{
                  payslip.account.pan_card_number
                }}</strong>
              </td>
            </tr>
            <tr style="height: 30px">
              <td class="border-none" colspan="2">
                <span>Employee ID: </span>
              </td>
              <td class="border-none text-left" colspan="4">
                <strong>{{
                  payslip.account.staff_hr_account.staff.employee_id
                }}</strong>
              </td>
              <td class="border-none" colspan="2">
                <span>Name : </span>
              </td>
              <td class="border-none text-left" colspan="4">
                <strong>{{
                  payslip.account.staff_hr_account.staff.full_name
                }}</strong>
              </td>
            </tr>
            <tr style="height: 30px">
              <td class="border-none" colspan="2">
                <span>Department : </span>
              </td>
              <td class="border-none text-left" colspan="4">
                <strong>{{
                  payslip.account.staff_hr_account.staff.department || "-"
                }}</strong>
              </td>
              <td class="border-none" colspan="2">
                <span>Designation : </span>
              </td>
              <td class="border-none text-left" colspan="4">
                <strong>{{
                  payslip.account.staff_hr_account.staff.designation || "-"
                }}</strong>
              </td>
            </tr>
            <tr style="height: 30px">
              <td v-if="payslipSettings.show_date_of_joining" class="border-none" colspan="2">
                <span>Date of Joining : </span>
              </td>
              <td v-if="payslipSettings.show_date_of_joining" class="border-none text-left" colspan="4">
                <strong>{{
                  payslip.account.staff_hr_account.staff.date_of_joining || "-"
                }}</strong>
              </td>
              <td class="border-none" colspan="2">
                <span v-if="payslipSettings.show_bank_details">PF Acc. no : </span>
                <span v-if="!payslipSettings.show_bank_details && !payslipSettings.show_attendance_details && !payslipSettings.show_payslip_number">
                  Pan Card no.
                </span>
              </td>
              <td class="border-none text-left" colspan="4">
                <strong v-if="payslipSettings.show_bank_details">{{ payslip.account.epf_number || "-" }}</strong>
                <strong v-if="!payslipSettings.show_bank_details && !payslipSettings.show_attendance_details && !payslipSettings.show_payslip_number">{{ payslip.account.pan_card_number || "-" }}</strong>

              </td>
            </tr>
            <tr style="height: 30px" v-if="payslipSettings.show_attendance_details || payslipSettings.show_bank_details">
              <td class="border-none" colspan="2">
                <span v-if="payslipSettings.show_attendance_details">Days Worked : </span>
              </td>
              <td class="border-none text-left" colspan="4">
                <strong v-if="payslipSettings.show_attendance_details"
                  >{{ payslip.monthly_attendance_data.worked_days || "-" }} /
                  {{
                    payslip.monthly_attendance_data.total_days || "-"
                  }}</strong
                >
              </td>
              <td class="border-none" colspan="2">
                <span v-if="payslipSettings.show_bank_details">Bank Name</span>
              </td>
              <td class="border-none text-left" colspan="4">
                <strong v-if="payslipSettings.show_bank_details">{{ payslip.account.bank_name || "-" }}</strong>
              </td>
            </tr>
            <tr style="height: 30px" v-if="payslipSettings.show_attendance_details || payslipSettings.show_bank_details">
              <td class="border-none" colspan="2">
                <span v-if="payslipSettings.show_attendance_details">Leaves : </span>
              </td>
              <td class="border-none text-left" colspan="4">
                <strong v-if="payslipSettings.show_attendance_details"
                  >{{ payslip.monthly_attendance_data.leaves || "-" }} ({{
                    payslip.monthly_attendance_data.unpaid_leaves || "-"
                  }}
                  Unpaid)</strong
                >
              </td>
              <td class="border-none" colspan="2">
                <span v-if="payslipSettings.show_bank_details">Bank Acc. no</span>
              </td>
              <td class="border-none text-left" colspan="4">
                <strong v-if="payslipSettings.show_bank_details">{{ payslip.account.account_number || "-" }}</strong>
              </td>
            </tr>
            <tr style="height: 30px" v-if="payslipSettings.show_attendance_details">
              <td class="border-none" colspan="2">
                <span >Half Days : </span>
              </td>
              <td class="border-none text-left" colspan="4">
                <strong
                  >{{ payslip.monthly_attendance_data.half_days || "-" }} ({{
                    payslip.monthly_attendance_data.unpaid_half_days || "-"
                  }}
                  Unpaid)</strong
                >
              </td>
              <td class="border-none" colspan="2">
                <span>Pan Card no.</span>
              </td>
              <td class="border-none text-left" colspan="4">
                <strong>{{ payslip.account.pan_card_number || "-" }}</strong>
              </td>
            </tr>
            <tr style="height: 30px" v-if="payslipSettings.show_attendance_details">
              <td class="border-none" colspan="2">
                <span v-if="payslipSettings.show_attendance_details">Loss of Pay : </span>
              </td>
              <td class="border-none text-left" colspan="4">
                <strong>
                  {{
                    Helper.currencyFormat(payslip.account.loss_of_pay) || "-"
                  }}
                </strong>
                <strong>{{
                  payslip.account.loss_of_pay ? "(Per day)" : ""
                }}</strong>
              </td>
              <td class="border-none" colspan="2"></td>
              <td class="border-none text-left" colspan="4"></td>
            </tr>
            <tr style="height: 30px" v-if="payslipSettings.show_attendance_details">
              <td class="border-none" colspan="2">
                <span>Overtime Hours : </span>
              </td>
              <td class="border-none text-left" colspan="4">
                <strong
                  >{{
                    payslip.monthly_attendance_data.overtime_days
                      ? moment
                          .duration(
                            payslip.monthly_attendance_data.overtime_hours
                          )
                          .asSeconds() == 0
                        ? "-"
                        : Helper.secondsToHms(
                            moment
                              .duration(
                                payslip.monthly_attendance_data.overtime_hours
                              )
                              .asSeconds()
                          )
                      : "-"
                  }}
                </strong>
                <strong
                  >({{
                    payslip.monthly_attendance_data.overtime_days
                      ? Helper.currencyFormat(payslip.account.ot_rate) +
                        " Per hour"
                      : ""
                  }})</strong
                >
              </td>
              <td class="border-none" colspan="2"></td>
              <td class="border-none text-left" colspan="4"></td>
            </tr>
            <tr style="height: 30px" v-if="payslipSettings.show_attendance_details">
              <td class="border-none" colspan="2">
                <span>Late Marks : </span>
              </td>
              <td class="border-none text-left" colspan="4">
                <strong>{{
                  payslip.monthly_attendance_data.late_marks || "-"
                }}</strong>
              </td>
              <td class="border-none" colspan="2"></td>
              <td class="border-none text-left" colspan="4"></td>
            </tr>
          </tbody>
        </table>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="6">
        <table class="border-right-none" style="width: 100%; background-color: white">
          <thead>
            <tr style="height: 30px">
              <th class="border-top-none" style="width: 40%">Earnings</th>
              <th class="border-top-none border-right-none" style="width: 60%">
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              style="height: 30px"
              v-for="transaction in earningTransactions"
              :key="transaction.id"
            >
              <td class="border-top-none">
                {{ transaction.particular.title }}
              </td>
              <td class="border-top-none border-right-none">
                <strong>{{ Helper.currencyFormat(transaction.amount) }}</strong>
              </td>
            </tr>
            <tr
              style="height: 30px"
              v-for="index in getExtraEarningRows()"
              :key="index"
            >
              <td class="border-top-none"></td>
              <td class="border-top-none border-right-none"></td>
            </tr>
            <tr
              style="height: 30px"
            >
              <td class="border-bottom-none">
                  <strong>Total Earnings</strong>
              </td>
              <td class="border-bottom-none">
                  <strong>{{ Helper.currencyFormat(getEarningTotal()) }}</strong>
              </td>
            </tr>

          </tbody>
        </table>
      </v-col>
      <v-col cols="6">
        <table class="border-left-none" style="width: 100%; background-color: white">
          <thead>
            <tr style="height: 30px">
              <th class="border-top-none" style="width: 40%">Deductions</th>
              <th class="border-top-none" style="widht: 60%">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr
              style="height: 30px"
              v-for="transaction in deductionTransactions"
              :key="transaction.id"
            >
              <td class="border-top-none">
                {{ transaction.particular.title }}
              </td>
              <td class="border-top-none">
                <strong>{{ Helper.currencyFormat(transaction.amount) }}</strong>
              </td>
            </tr>
            <tr
              style="height: 30px"
              v-for="index in getExtraDeductionRows()"
              :key="index"
            >
              <td class="border-top-none"></td>
              <td class="border-top-none"></td>
            </tr>
            <tr
              style="height: 30px"
            >
              <td class="border-bottom-none ">
                  <strong>Total Deductions</strong>
              </td>
              <td class="border-bottom-none">
                  <strong>{{ Helper.currencyFormat(getDeductionTotal()) }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <table style="width: 100%; background-color: white" class="table">
          <tbody>
            <!-- <tr style="height: 30px">
              <td style="width: 56px; height: 30px"></td>
              <td style="width: 54.6667px; height: 30px"></td>
              <td style="width: 55.3333px; height: 30px"></td>
              <td style="width: 56px; height: 30px"></td>
              <td style="width: 54px; height: 30px"></td>
              <td style="width: 53px; height: 30px"></td>
              <td style="width: 56px; height: 30px"></td>
              <td style="width: 52px; height: 30px"></td>
              <td style="width: 55px; height: 30px"></td>
              <td style="width: 56px; height: 30px"></td>
              <td style="width: 56px; height: 30px"></td>
              <td style="width: 56px; height: 30px"></td>
            </tr> -->

            <tr style="height: 30px">
                <td class="border-none" style="width:20%"></td>
              <td
                class="border-top-none border-left-none" 
                style="width:30%"
              >
                <strong>Total Salary</strong>
              </td>
              <td class="border-top-none" colspan="6">
                <strong>{{ Helper.currencyFormat(payslip.net_salary) }}</strong>
              </td>
            </tr>
            <tr style="height: 30px" v-if="payslipSettings.show_amount_in_words">
              <td colspan="1">
                <strong> Amount in words</strong>
              </td>
              <td colspan="11">
                  <strong v-if="payslip.net_salary">{{ Helper.number2text(Number(payslip.net_salary)) }}</strong>
              </td>
            </tr>
            <tr style="height: 30px">
              <td colspan="1">
                <strong>Mode</strong>
              </td>
              <td colspan="1" style="width:10%">
                  {{ payslip.mode }}
              </td>
              <td colspan="1" style="width:20%">
                <strong>Remarks</strong>
              </td>
              <td>{{ payslip.remarks }}</td>
            </tr>
            <tr style="height: 30px" v-if="payslipSettings.show_signature_fields">
              <td colspan="2" class="border-edges-none"></td>
              <td colspan="2" class="border-edges-none"></td>
            </tr>
            <tr style="height: 30px" v-if="payslipSettings.show_signature_fields">
              <td colspan="2" class="border-top-none">
                <strong>Employer's Signature</strong>
              </td>
              <td colspan="2" class="border-top-none">
                <strong> Employee's Signature</strong>
              </td>
            </tr>
            <tr style="height: 30px">
                <td colspan="1" class="border-right-none">Note:</td>
              <td class="text-left border-left-none" colspan="11">{{ payslipSettings.notes }}</td>
            </tr>
          </tbody>
        </table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Helper from "@utils/misc";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "PayslipTable",
  props: ["payslip","payslipSettings"],
  data() {
    return {
      Helper: Helper,
      moment: moment,
      earningTransactions: [],
      deductionTransactions: [],
    };
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "currentInstitution",
      "accessToken",
      "isLoading",
    ]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    setEarningTransactions() {
      let earning_transactions = this.payslip.payslip_transactions.filter(
        (transaction) => transaction.particular.particular_type == "E"
      );
      let dynamic_earning_transactions = this.payslip.payslip_dynamic_transactions.filter(
        (transaction) => transaction.particular.particular_type == "E"
      );
      this.earningTransactions = earning_transactions.concat(
        dynamic_earning_transactions
      );
    },
    setDeductionTransactions() {
      let deduction_transaction = this.payslip.payslip_transactions.filter(
        (transaction) => transaction.particular.particular_type == "D"
      );
      let dynamic_deduction_transactions = this.payslip.payslip_dynamic_transactions.filter(
        (transaction) => transaction.particular.particular_type == "D"
      );
      this.deductionTransactions = deduction_transaction.concat(
        dynamic_deduction_transactions
      );
    },
    getExtraEarningRows() {
      var extra_earning_rows =
        this.deductionTransactions.length - this.earningTransactions.length;
      if (extra_earning_rows > 0) return extra_earning_rows;
      else return 0;
    },
    getExtraDeductionRows() {
      var extra_deduction_rows =
        this.earningTransactions.length - this.deductionTransactions.length;
      if (extra_deduction_rows > 0) return extra_deduction_rows;
      else return 0;
    },
    getEarningTotal() {
      return Helper.totalSum(this.earningTransactions, "amount");
    },
    getDeductionTotal() {
      return Helper.totalSum(this.deductionTransactions, "amount");
    },
  },
  created() {
    if (!this.payslip) {
      this.$router.push({ name: "PayrollDashboard" });
    }
    this.setEarningTransactions();
    this.setDeductionTransactions();
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
}
.border-bottom-none {
  border-bottom: none;
}
.border-top-none {
  border-top: none;
}
.border-edges-none {
  border-top: none;
  border-bottom: none;
}
.border-left-none {
  border-left: none;
}
.border-right-none {
  border-right: none;
}
.border-sides-none {
  border-left: none;
  border-right: none;
}
.border-none {
  border: none;
}
</style>

<style media="print" scoped>
table,
th,
td {
  border-collapse: collapse;
}
</style>